import type { User } from "@/models/user";
import type { Client } from "@/models/client";
import type { DateTime } from "luxon";

export type CardApiDto = {
  id: number;
  userId: number;
  clientId: number;
  name: string;
  system: string;
  currencyCode: string;
  lastDigits: string;
  expiryMonth: string;
  expiryYear: string;
  status: string;
  billing: boolean;
  createdAt: string;
  updatedAt: string;

  user?: User;
  client?: Client;
}

export enum CardSystem {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMERICAN_EXPRESS = 'amex',
}

export enum CardCurrencyCode {
  CAD = 'CAD',
  USD = 'USD',
}

export type CardActionType = 'activate' | 'pause' | 'delete' | 'set-primary';

export enum CardActions {
  ACTIVATE = 'activate',
  DELETE = 'delete',
  PAUSE = 'pause',
  SET_PRIMARY = 'set-primary',
}

export enum CardStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  DELETED = 'deleted',
  EXPIRED = 'expired',
}

export type Card = {
  id: number;
  userId: number;
  clientId: number;
  name: string;
  system: CardSystem;
  currencyCode: string;
  lastDigits: string;
  expiryMonth: string;
  expiryYear: string;
  status: CardStatus;
  billing: boolean;
  createdAt: DateTime;
  updatedAt: DateTime;

  user?: User;
  client?: Client;
}

export type FormEventPayload = {
  name: string;
  system: CardSystem;
  platformData: {
    [ key: string ]: string;
    cardToken: string;
  };
};
